import React from 'react';
import { Box, Container, Heading, Text, SimpleGrid, VStack, useColorModeValue, Divider, Flex, Icon } from '@chakra-ui/react';
import { Award, Users, Briefcase, CreditCard, BookOpen } from 'lucide-react';
const AchievementCard = ({
  title,
  description,
  icon
}) => {
  const cardBg = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  return <Box p={6} borderRadius="lg" bg={cardBg} boxShadow="md" border="1px" borderColor={borderColor} height="100%" data-id="element-78">
      <Flex w={12} h={12} align="center" justify="center" borderRadius="full" bg="blue.100" color="blue.600" mb={4} data-id="element-79">
        <Icon as={icon} boxSize={6} data-id="element-80" />
      </Flex>
      <Heading as="h3" size="md" mb={3} data-id="element-81">
        {title}
      </Heading>
      <Text color={useColorModeValue('gray.600', 'gray.300')} data-id="element-82">
        {description}
      </Text>
    </Box>;
};
export function Achievements() {
  const bgColor = useColorModeValue('gray.50', 'gray.900');
  const achievements = [{
    title: 'Production-Ready Platforms',
    description: 'Built and deployed production-ready platforms used by real businesses across Africa.',
    icon: Award
  }, {
    title: 'Robotics Competition Judge',
    description: 'Served as Head Judge for robotics competitions in schools across Ghana.',
    icon: BookOpen
  }, {
    title: 'Client Onboarding Lead',
    description: 'Led client onboarding and delivery for multi-module SaaS platforms.',
    icon: Users
  }, {
    title: 'Payment Systems Expert',
    description: 'Built Stripe and Paystack payment systems from scratch for multiple platforms.',
    icon: CreditCard
  }, {
    title: 'STEM Outreach Leader',
    description: 'Spearheaded outreach STEM programs with real impact on students across Ghana.',
    icon: Briefcase
  }];
  return <Box id="achievements" py={20} bg={bgColor} width="100%" data-id="element-83">
      <Container maxW="1200px" data-id="element-84">
        <VStack spacing={12} data-id="element-85">
          <VStack spacing={4} textAlign="center" maxW="800px" data-id="element-86">
            <Heading as="h2" size="xl" data-id="element-87">
              Achievements & Highlights
            </Heading>
            <Divider width="100px" borderColor="blue.500" borderWidth={2} data-id="element-88" />
            <Text fontSize="lg" color={useColorModeValue('gray.600', 'gray.300')} data-id="element-89">
              Key accomplishments from my professional journey
            </Text>
          </VStack>
          <SimpleGrid columns={{
          base: 1,
          md: 2,
          lg: 3
        }} spacing={8} data-id="element-90">
            {achievements.map((achievement, index) => <AchievementCard key={index} {...achievement} data-id="element-91" />)}
          </SimpleGrid>
        </VStack>
      </Container>
    </Box>;
}